module.exports = __webpack_public_path__ + "img/mind_background_3_th.ff8e7b79.png";